module.exports = __webpack_public_path__ + "assets/img/1-3.d98a6e55.png";